import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';

export default function HomeFooter() {
  return (
    <footer className="bg-card border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 2xl:px-16 py-12">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-8 mb-10">
          <div className="col-span-2 md:col-span-2">
            <div className="flex items-center gap-2 mb-3">
              <AppLogo size={32} />
              <span className="font-extrabold text-lg text-foreground">Monezite</span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              The open innovation platform connecting real problems, entrepreneurial solutions, and investor capital.
            </p>
          </div>
          {[
            {
              id: 'footer-platform',
              title: 'Platform',
              links: [
                { label: 'Browse Problems', href: '/problem-solution-board' },
                { label: 'Browse Solutions', href: '/problem-solution-board?tab=solutions' },
                { label: 'Funded Deals', href: '/problem-solution-board?tab=funded' },
                { label: 'Marketplace', href: '/marketplace' },
              ],
            },
            {
              id: 'footer-roles',
              title: 'For You',
              links: [
                { label: 'Problem Posters', href: '/sign-up-login-screen?mode=signup&role=poster' },
                { label: 'Entrepreneurs', href: '/sign-up-login-screen?mode=signup&role=entrepreneur' },
                { label: 'Investors', href: '/sign-up-login-screen?mode=signup&role=investor' },
              ],
            },
            {
              id: 'footer-company',
              title: 'Company',
              links: [
                { label: 'About', href: '#' },
                { label: 'Blog', href: '#' },
                { label: 'Careers', href: '#' },
              ],
            },
          ]?.map((col) => (
            <div key={col?.id}>
              <p className="text-xs font-semibold text-foreground uppercase tracking-wider mb-3">{col?.title}</p>
              <ul className="space-y-2">
                {col?.links?.map((link) => (
                  <li key={`footer-link-${link?.label}`}>
                    <Link href={link?.href} className="text-sm text-muted-foreground hover:text-foreground transition-colors">
                      {link?.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="border-t border-border pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-muted-foreground">© 2026 Monezite Inc. All rights reserved.</p>
          <div className="flex items-center gap-4">
            <Link href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Privacy</Link>
            <Link href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Terms</Link>
            <Link href="#" className="text-xs text-muted-foreground hover:text-foreground transition-colors">Contact</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}